import React, {useMemo, useState} from "react";
import Chips, {ChipsIconPosition, ChipsTypes} from "../../../../../components/base/chips/chips";
import SerialBarcodeDialog from "../../../../../components/dialogs/serial-barcode";
import {dataGridCellTextProps} from "../../../../../../packages/data-grid";

/**
 * Read-only serial chips that open the barcode dialog (show / download).
 * Accepts string serials or `{serialNumber}` objects.
 */
const PurchaseSerialNumberChips = ({serials = []}) => {
    const [selectedSerial, setSelectedSerial] = useState(null);

    const normalized = useMemo(() => (
        (Array.isArray(serials) ? serials : [])
            .map((entry, index) => {
                if (typeof entry === 'string') {
                    return {id: `${entry}-${index}`, serialNumber: entry};
                }
                return {
                    id: entry?.id ?? entry?.serialNumber ?? index,
                    serialNumber: entry?.serialNumber ?? '',
                };
            })
            .filter((entry) => !!entry.serialNumber)
    ), [serials]);

    const chips = useMemo(() => (
        normalized.map((serial) => (
            <span key={serial.id} {...dataGridCellTextProps} className={'mr-2 mb-2'}>
                <Chips
                    type={ChipsTypes.next}
                    iconPosition={ChipsIconPosition.end}
                    content={serial.serialNumber}
                    onIconClick={() => setSelectedSerial(serial)}
                />
            </span>
        ))
    ), [normalized]);

    return (
        <>
            <div className={'d-flex w-100 flex-wrap'}>
                {chips.length ? chips : <span {...dataGridCellTextProps}>--</span>}
            </div>
            <SerialBarcodeDialog
                open={!!selectedSerial}
                setOpen={() => setSelectedSerial(null)}
                serial={selectedSerial}
            />
        </>
    );
};

export default PurchaseSerialNumberChips;
